
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgIconChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon-Chevron Down",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8037",
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.726 18.47l-7.078-6.781a1.028 1.028 0 00-.648-.281.941.941 0 00-.614.248l-7.111 6.815A.888.888 0 109.5 19.752l6.5-6.227 6.5 6.222a.887.887 0 001.23-1.278z"
  })));
}

export { SvgIconChevronUp as default };
//# sourceMappingURL=icon-chevron-up.svg.js.map
